import { render } from "./ReportProjectCommentModal.vue?vue&type=template&id=387d0fdb"
import script from "./ReportProjectCommentModal.vue?vue&type=script&lang=js"
export * from "./ReportProjectCommentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__